import { MOCK_IMPORT_ROWS_EN } from './locales/en/mock-import.js';
import { MOCK_IMPORT_ROWS_EN_US } from './locales/en-us/mock-import.js';
import { MOCK_IMPORT_ROWS_JA } from './locales/ja/mock-import.js';
import { MOCK_IMPORT_ROWS_KO } from './locales/ko/mock-import.js';
import { MOCK_IMPORT_ROWS_ZH_CN } from './locales/zh-cn/mock-import.js';
import { MOCK_IMPORT_ROWS_ZH_TW } from './locales/zh-tw/mock-import.js';

/** @type {Record<string, Array<import('./locales/en/mock-import.js').MockImportRow>>} */
const ROWS = {
	en: MOCK_IMPORT_ROWS_EN,
	'en-US': MOCK_IMPORT_ROWS_EN_US,
	ja: MOCK_IMPORT_ROWS_JA,
	ko: MOCK_IMPORT_ROWS_KO,
	'zh-CN': MOCK_IMPORT_ROWS_ZH_CN,
	'zh-TW': MOCK_IMPORT_ROWS_ZH_TW,
};

/** @type {Record<string, string>} */
const SYMBOL = {
	en: '\u00A3',
	'en-US': '$',
	ja: '\u00A5',
	ko: '\u20A9',
	'zh-CN': '\u00A5',
	'zh-TW': 'NT$',
};

/**
 * @param {string} lang
 * @returns {{ rows: Array<import('./locales/en/mock-import.js').MockImportRow>, symbol: string }}
 */
export function getMockImport(lang) {
	return {
		rows: ROWS[lang] ?? MOCK_IMPORT_ROWS_EN,
		symbol: SYMBOL[lang] ?? '\u00A3',
	};
}
